import OfferAdvancedView from './OfferAdvancedView'

export default OfferAdvancedView
